<!--<app-loader *ngIf="readyData === false"></app-loader>-->
<ngx-spinner name="loader"><p style="color: white;font-size: 1.1rem;"> Processing data...</p></ngx-spinner>

<mat-toolbar color="primary" class="example-toolbar">
  <app-navbar style="width: 100%;">
    <button class="btn-sidebar" id="btn-sidebar" (click)="sidenav.toggle();"><mat-icon slot="start">menu</mat-icon></button>
  </app-navbar>
</mat-toolbar>


<mat-sidenav-container
    class="example-container" (backdropClick)="close('backdrop')">
  <mat-sidenav [mode]="'over'" class="sidenav-menu" #sidenav (keydown.escape)="close('escape')" disableClose>
    <app-sidebar></app-sidebar>
  </mat-sidenav>

  <mat-sidenav-content style="padding-bottom: 3rem;">

    <router-outlet></router-outlet>
    <!-- <app-footer></app-footer> -->
  </mat-sidenav-content>

</mat-sidenav-container>

